import { ActionTypesUser } from "../constants/action-types"

const initialState = {
    signIn:{
        loading:false,
        error:null,
        data:null,
        params:null,
    },
    signOut:{
        loading:false,
        error:null,
    },
    isSignedOut:false,
    data:null,
}

const preChatReducer = (state=initialState, {type, payload}) => {
    switch(type){
        case ActionTypesUser.USER_SIGN_IN_REQUEST:{
            return {
                signIn:{
                    loading:true,
                    error:null,
                    data:payload.signInData,
                    params:payload.params,
                },
                data:null,
            }
        }

        case ActionTypesUser.USER_SIGN_IN_ERROR:{
            return {
                ...state,
                signIn:{
                    loading:false,
                    error:payload.error,
                }
            }
        }

        case ActionTypesUser.USER_SIGN_IN_SUCCESS:{
            return {
                ...state,
                signIn:{
                    ...state.signIn,
                    loading:false,
                },
                data:payload.user
            }
        }


        case ActionTypesUser.USER_SIGN_OUT_REQUEST:{
            return {
                ...state,
                isSignedOut:true,
                signOut:{
                    loading:true,
                    error:null
                }
            }
        }

        case ActionTypesUser.USER_SIGN_OUT_SUCCESS:{
            return {
                ...state,
                data:null,
                signOut:{
                    loading:false,
                    error:null
                }
            }
        }

        case ActionTypesUser.USER_SIGN_OUT_ERROR:{
            return {
                ...state,
                signOut:{
                    loading:false,
                    error:payload.error,
                }
            }
        }

        default:{
            return state;
        }
    }
}

export default preChatReducer;
